export const popularizeModalPersonal = {
  stepOne: {
    title: "步骤一：体验电脑端",
    description: "复制链接前往电脑端打开即可试用"
  },
  stepTwo: {
    title: "步骤二：体验手机端",
    description: "扫描下方二维码关注公众号 点击底部菜单云服务-尊享版"
  },
  stepThree: {
    title: "步骤三：查看手册",
    description: "复制链接前往电脑端查看即可半天学会"
  },
  button: {
    copyLink: "复制链接",
    follow: "去关注"
  },
  message: {
    copySuccess: '复制到剪贴板成功',
    copyGZHSuccess: '复制成功，请去微信搜索关注'
  },
  name: '福昕家装云服务'
}
